import React, { useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import * as NotificationAPI from '../../services/NotificationServices';
import styles from './styles/JoinClassroomModal.module.css';
import { ClassroomContext } from '../../context/ClassroomContext';
import { FaTimes } from 'react-icons/fa';

const JoinClassroomModal = ({ isOpen, onClose }) => {
    const [code, setCode] = useState(['', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputs = useRef([]);
    
    const navigate = useNavigate();
    const { setJoinedClassrooms } = useContext(ClassroomContext);

    if (!isOpen) return null;

    const handleChange = (e, index) => {
        const value = e.target.value;
        const char = value.slice(-1);
        const newCode = [...code];
        newCode[index] = char;
        setCode(newCode);

        
        if (char && index < 4) {
            inputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('Text').trim();
        
        
        const pastedChars = pastedData.split('').slice(0, 5);
        
        const newCode = [...code];
        pastedChars.forEach((char, index) => {
            newCode[index] = char;
        });

        setCode(newCode);

        
        const nextIndex = pastedChars.length >= 5 ? 4 : pastedChars.length;
        if (inputs.current[nextIndex]) {
            inputs.current[nextIndex].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fullCode = code.join('');
        if (fullCode.length < 5) {
            setError('Please enter the full 5-character code.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const data = await NotificationAPI.joinClassroomFromCode(fullCode);
            const { classroom } = data;

            if (classroom && classroom._id) {
                setJoinedClassrooms((prev) => [...prev, classroom]);
                
                onClose();
                setCode(['', '', '', '', '']); 
                
                navigate(`/my-classrooms/${classroom._id}/d`); 
            } else {
                throw new Error("Classroom data missing from response");
            }

        } catch (err) {
            console.error("Join Error:", err);
            setError(err.response?.data?.message || 'Invalid code or already joined.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeBtn} onClick={onClose}><FaTimes /></button>
                
                <h2>Join Classroom</h2>
                <p>Enter the 5-character code provided by your teacher.</p>

                <form onSubmit={handleSubmit}>
                    <div className={styles.codeContainer}>
                        {code.map((char, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputs.current[index] = el)}
                                type="text"
                                maxLength="5" 
                                value={char}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onPaste={handlePaste} 
                                className={styles.codeInput}
                                autoComplete="off"
                            />
                        ))}
                    </div>

                    {error && <div className={styles.error}>{error}</div>}

                    <button 
                        type="submit" 
                        className={styles.submitBtn} 
                        disabled={loading}
                    >
                        {loading ? 'Joining...' : 'Join Classroom'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default JoinClassroomModal;